import axios from '../../axios'
import React, { useEffect, useState,useMemo } from 'react'
import "./Dashboard.css"
import { Link } from 'react-router-dom/cjs/react-router-dom'
import ProductSkeleton from '../skeleton/ProductSkeleton'
import swal from 'sweetalert'
import Pagination from "./pagination/Pagination"
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { useStateValue } from '../../StateProvider'
import PaginationSkeleton from '../skeleton/PaginationSkeleton'
import FilterModal from "./FilterModal"

let PageSize = 4;
const Dashboard = () => {
    const [{admin_search,admin_search_loading},dispatch]=useStateValue()
    const [currentPage, setCurrentPage] = useState(1);
    const cacheCategory=localStorage.getItem('category')
    const [category,setCategory]=useState(cacheCategory?cacheCategory:'All')
    const [categories,setCategories]=useState([])
    const [sortedData,setSortedData]=useState(admin_search)

    const currentTableData = useMemo(() => {
      const firstPageIndex = (currentPage - 1) * PageSize;
      const lastPageIndex = firstPageIndex + PageSize;
      return sortedData.slice(firstPageIndex, lastPageIndex);
    }, [currentPage,admin_search,sortedData]);

    useEffect(()=>{
        setCurrentPage(1)
        setSortedData(admin_search)
    },[admin_search])
    useEffect(()=>{
        axios({  
            method:'get',
            url:'/products/get/category'
        }).then(res => setCategories(res.data)).catch(err => console.log(err))
    },[])

    useEffect(()=>{
      setCurrentPage(1)
    },[sortedData.length])
    useEffect(()=>{
        setCategory(category)
        getProducts()
        setCurrentPage(1)
    },[category])
    const getProducts = async () => {
        dispatch({
            type:"ADMIN_SEARCH_LOADING",
            payload:true
        })
        if(category=='All'){
            await axios({
                method: 'get',
                url: `/products/get/all`
            }).then(res => {
                dispatch({
                    type:'ADMIN_SEARCH_PRODUCTS',
                    payload:res.data
                  }) 
                  dispatch({
                    type:"ADMIN_SEARCH_LOADING",
                    payload:false
                })
            }).catch(err => console.log(err))
        }
        else{
            await axios({
                method: 'get',
                url: `/products/category/${category}`
            }).then(res => {
                dispatch({
                    type:'ADMIN_SEARCH_PRODUCTS',
                    payload:res.data
                  }) 
                  dispatch({
                    type:"ADMIN_SEARCH_LOADING",
                    payload:false
                })
            }).catch(err => console.log(err))
        }
    }

    const handleSelect=(e)=>{
        dispatch({
            type:'ADMIN_SEARCH_PRODUCTS',
            payload:[]
          })
        setCategory(e.target.value)
        localStorage.setItem('category',e.target.value)
    }

    const deleteProduct=(p)=>{
        swal({
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover this product!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
          })
          .then((willDelete) => {
            if (willDelete) {
                axios({
                    url:`/products/delete/${p._id}`,
                    method:'post',
                    data:p
                })
                .then(res=>{
                    getProducts()
                    swal("Product has been deleted!", {
                        icon: "success",
                      });
                    }
                )
              
            } 
          });
    }

    return (
        <div className='container-fluid dashboard'>
            <div className='row'>
                <div className='col-md-6'>
                <p className='mt-2'>
                <select value={category==undefined?'All':category} onChange={handleSelect} >
                    <option>All</option>
                    {
                        categories.sort((a, b) => a._id.localeCompare(b._id)).map((c,i)=>
                            <option key={i}>{c._id}</option>
                        )
                    }
                </select>
                <span className='ml-2 mr-2'>{sortedData.length} Products</span>
                <FilterModal setSortedData={setSortedData} category={category}/>
                <span><Link to='/admin/add-product' className='text-dark'><AddBoxIcon className='ml-3' fontSize='large'/></Link></span>
            </p>
                </div>
            </div>
            { admin_search.length>0&&
                        <pre>
                        <table border="1" className='bg-white'>
                          <thead>
                            <tr>
                              <th className='p-1 text-center'>Image</th>
                              <th className='p-1 text-center'>Title</th>
                              <th className='p-1 text-center'>Price</th>
                              <th className='p-1 text-center'>Edit/Delete</th>
                              <th className='p-1 text-center'>stock</th>
                            </tr>
                          </thead>
                          <tbody>
                            {currentTableData.map(p => {
                              return (
                                <tr key={p._id}>
                                  <td><img src={p.image} width='100px' height='100px' style={{objectFit:'contain'}}/></td>
                                  <td>{p.title}</td>
                                  <td className='text-center'>₹{p.price}</td>
                                  <td>
                                  <Link className='text-success pl-3' to={`/admin/edit/${p._id}`} ><EditIcon/></Link>
                                  <DeleteIcon className='text-danger' onClick={()=>deleteProduct(p)}/>
                                  </td>
                                  <td className='text-center'>{p.stock<1?'0':p.stock}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </pre>
            }

          <Pagination
            className="pagination-bar"
            currentPage={currentPage}
            totalCount={sortedData.length}
            pageSize={PageSize}
            onPageChange={page => setCurrentPage(page)}
          />
            <div className='row'>
                {admin_search_loading&&admin_search.length<1&&
                <PaginationSkeleton/>
                }
               {admin_search.length==0&&admin_search_loading===false&&
               <article className='col-md-3 col-sm-4'>
                <h1>Product you are looking is not available</h1>
                </article>}
            </div>
        </div>
    )
}

export default Dashboard
